import React from 'react';
import StyledPulsingDot from './PulsingDot.style';
import type { PulsingDotColor } from './PulsingDot.style';

interface PulsingDotProps {
  /* What the dot says, for anyone who cannot see it pulse: a screen reader
     reads it, and hovering the dot shows it. Required - a dot on its own is
     not self-explanatory. */
  label: string;
  color?: PulsingDotColor;
  /* So the dot can be placed by a styled() wrapper, which is how the spacing
     around it is set - see the styling conventions */
  className?: string;
}

const PulsingDot = ({ label, color = 'blue', className }: PulsingDotProps) => (
  <StyledPulsingDot
    className={className}
    $color={color}
    role="img"
    aria-label={label}
    title={label}
    data-test-pulsing-dot
  />
);

export default PulsingDot;
